import { UserApi } from "../openapi";
import openApiConfig from "./http_service";

const userApi=new UserApi(openApiConfig)

export default userApi